/* eslint-disable */
class isoTope {
  constructor() {
    this.init()
  }

  async init() {
    const mountObject = document.querySelector("#package-museum-wrap")
    if (!mountObject) return

    const { default: isotope } = await import(/* webpackChunkName: 'vueisotope' */ "vueisotope")
    const { default: imagesLoaded } = await import(/* webpackChunkName: 'vue-images-loaded' */ "vue-images-loaded")
    const { default: SweetScroll } = await import(/* webpackChunkName: 'SweetScroll' */ "sweet-scroll")
    const Scroll = new SweetScroll({
      duration: 800,
      easing: "easeOutQuint",
    })
    Vue.component("isotope", isotope)

    const app = new Vue({
      el: "#package-museum-wrap",
      directives: {
        imagesLoaded,
      },
      data: function () {
        return {
          post: [],
          options: {
            percentPosition: true,
            itemSelector: ".grid-item",
            masonry: {
              gutter: 15,
            },
          },
          apiUrl: "https://www.berry-b.jp/wp-json/wp/v2/work?",
          per_page: 12,
          page: 0,
          query: "",
          showFlag: true,
        }
      },
      mounted: async function () {
        console.log("mout4eds")
        await this.load()
      },
      computed: {
        queryUrl: function () {},
      },
      methods: {
        load: async function () {
          this.page = this.page + 1
          const _this = this
          const { default: axios } = await import(/* webpackChunkName: 'axios' */ "axios")
          await axios
            .get(this.getApiUrl())
            .then(async (res) => {
              _this.showFlag = true
              res.data.forEach((element) => {
                _this.post.push(element)
              })
              if (res.data.length == 0) {
                _this.showFlag = false
              }
            })
            .catch((error) => {
              if (error.response.status == 400) {
                _this.showFlag = false
              }
            })
        },
        getApiUrl: function () {
          //this.apiUrl = this.query !== '' ? wpapi_search : wpapi
          return this.apiUrl + this.per_page + "&page=" + this.page + "&search=" + this.query
        },
        resetQuery: async function () {
          this.post = []
          this.query = ""
          this.page = 0
          this.load()
          this.$nextTick(async () => {
            await Scroll.to("#page-top")
          })
        },
        layout: function () {
          this.$refs.cpt.layout("masonry")
        },
        search: function () {
          this.post = []
          this.page = 0
          this.load()
        },
      },
    })
  }
}
export default new isoTope()
